// extracted by mini-css-extract-plugin
module.exports = {"ActionArea":"ActionArea--ActionArea--APLN1GF"};